(function () {
  const modal = document.getElementById('VatCheckoutPopup');
  if (!modal) return;

  const checkoutButtons = Array.from(
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]')
  );

  const closeButtons = Array.from(modal.querySelectorAll('[data-vat-close]'));
  const typeButtons = Array.from(modal.querySelectorAll('[data-vat-type]'));
  const continueButton = modal.querySelector('[data-vat-continue]');
  const backButton = modal.querySelector('[data-vat-back]');
  const vatInput = modal.querySelector('[name="vat_number"]');
  const errorBox = modal.querySelector('[data-vat-error]');
  const form = modal.querySelector('[data-vat-form]');
  const typeStep = modal.querySelector('[data-vat-step="type"]');
  const vatStep = modal.querySelector('[data-vat-step="vat"]');

  const cartUpdateUrl = (window.theme && window.theme.routes && window.theme.routes.cartUpdate) || '/cart/update.js';
  const nativeFormSubmit = HTMLFormElement.prototype.submit;

  let pendingCheckout = false;
  let lastFocusedEl = null;
  let currentType = 'private';

  function setError(message) {
    if (!errorBox) return;
    errorBox.textContent = message || '';
    errorBox.hidden = !message;
  }

  function normalizeVat(value) {
    return (value || '').trim().replace(/\s+/g, '').toUpperCase();
  }

  function vatLooksValid(value) {
    return /^[A-Z]{2}[A-Z0-9]{6,14}$/.test(value);
  }

  function showStep(step) {
    if (typeStep) {
      typeStep.hidden = step !== 'type';
      typeStep.style.display = step === 'type' ? 'grid' : 'none';
    }
    if (vatStep) {
      vatStep.hidden = step !== 'vat';
      vatStep.style.display = step === 'vat' ? 'grid' : 'none';
    }
  }

  function resetPopup() {
    currentType = 'private';
    if (vatInput) vatInput.value = '';
    setError('');
    showStep('type');
  }

  async function getCart() {
    const response = await fetch((window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) {
      throw new Error('Kon winkelwagen niet ophalen.');
    }
    return response.json();
  }

  async function updateCartAttributes(nextAttributes) {
    const cart = await getCart();
    const mergedAttributes = Object.assign({}, cart.attributes || {}, nextAttributes);

    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes: mergedAttributes })
    });

    if (!response.ok) {
      throw new Error('Kon klantgegevens niet bewaren.');
    }
    return response.json();
  }

  function openModal() {
    pendingCheckout = true;
    lastFocusedEl = document.activeElement;
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vat-checkout-modal-open');
    document.body.classList.add('vat-checkout-modal-open');
    resetPopup();
    const firstButton = typeButtons[0];
    if (firstButton) firstButton.focus();
  }

  function closeModal() {
    pendingCheckout = false;
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vat-checkout-modal-open');
    document.body.classList.remove('vat-checkout-modal-open');
    setError('');
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
      lastFocusedEl.focus();
    }
  }

  function redirectToCheckout() {
    pendingCheckout = false;
    window.location.href = '/checkout';
  }

  async function persistCheckoutAttributes(nextAttributes) {
    try {
      await updateCartAttributes(nextAttributes);
    } catch (error) {
      // Fail open: checkout should remain available even if the cart attribute write fails.
      // The customer is better served by completing the order than being blocked here.
      console.warn('[vat-checkout-popup] Could not persist cart attributes before checkout.', error);
    }

    redirectToCheckout();
  }

  async function continueToCheckout() {
    if (currentType !== 'company') {
      return;
    }

    const vatNumber = normalizeVat(vatInput ? vatInput.value : '');
    if (!vatNumber) {
      setError('Vul je BTW-nummer in met landscode (bv. BE0123456789).');
      if (vatInput) vatInput.focus();
      return;
    }
    if (!vatLooksValid(vatNumber)) {
      setError('Vul je BTW-nummer in met landscode (bv. BE0123456789).');
      if (vatInput) vatInput.focus();
      return;
    }

    if (continueButton) continueButton.disabled = true;
    try {
      await persistCheckoutAttributes({ vat_customer_type: 'company', vat_number: vatNumber });
    } finally {
      if (continueButton) continueButton.disabled = false;
    }
  }

  async function continueAsPrivate() {
    await persistCheckoutAttributes({ vat_customer_type: 'private', vat_number: '' });
  }

  function isCheckoutForm(formEl) {
    if (!formEl) return false;
    return !!formEl.querySelector('button[name="checkout"], input[name="checkout"]');
  }

  function shouldInterceptCheckoutTarget(target) {
    const checkoutControl = target && target.closest ? target.closest('button[name="checkout"], input[name="checkout"]') : null;
    if (!checkoutControl) return false;
    return isCheckoutForm(checkoutControl.closest('form'));
  }

  function handleCheckoutAttempt(event) {
    if (pendingCheckout || modal.classList.contains('is-active')) return;
    if (!shouldInterceptCheckoutTarget(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openModal();
  }

  document.addEventListener('click', handleCheckoutAttempt, true);
  document.addEventListener('submit', (event) => {
    if (pendingCheckout || modal.classList.contains('is-active')) return;
    if (!isCheckoutForm(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openModal();
  }, true);

  HTMLFormElement.prototype.submit = function patchedSubmit() {
    if (isCheckoutForm(this) && !pendingCheckout && !modal.classList.contains('is-active')) {
      openModal();
      return;
    }
    return nativeFormSubmit.apply(this, arguments);
  };

  typeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      currentType = button.getAttribute('data-vat-type') || 'private';
      setError('');
      if (currentType === 'company') {
        showStep('vat');
        if (vatInput) vatInput.focus();
        return;
      }
      continueAsPrivate();
    });
  });

  if (backButton) {
    backButton.addEventListener('click', (event) => {
      event.preventDefault();
      currentType = 'private';
      setError('');
      showStep('type');
      const firstButton = typeButtons[0];
      if (firstButton) firstButton.focus();
    });
  }

  closeButtons.forEach((button) => button.addEventListener('click', closeModal));
  if (continueButton) continueButton.addEventListener('click', continueToCheckout);
  if (vatInput) vatInput.addEventListener('input', () => setError(''));

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    continueToCheckout();
  });

  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target.hasAttribute('data-vat-backdrop')) {
      closeModal();
    }
  });
})();
